const ReportStatus = {
  InProgress: "in progress",
  Success: "success",
  Cancelled: "cancelled",
  Failed: "failed",
};

export default ReportStatus;
